import React from 'react';
import classes from './Tick.module.css';

const Tick = (props) => {
    return (
        <div className={props.class} style={{ display: 'flex', alignItems: 'center' }}>
            <svg
                className={`${classes.tick} ${props.visible ? classes.visible : ''}`}
                style={{ width: props.size ? props.size : '', height: props.size ? props.size : '' }}
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    x="0.5"
                    width={props.size ? props.size : '14'}
                    height={props.size ? props.size : '14'}
                    rx="7"
                    fill={props.fill ? props.fill : '#64EABB'}
                />
                <path
                    fill="white"
                    d="M5.53311 6.90035C5.23868 6.60592 4.76132 6.60592 4.46689 6.90035C4.17246 7.19478 4.17246 7.67215 4.46689 7.96658L5.53311 6.90035ZM6.46656 8.90002L5.93345 9.43314C6.07484 9.57453 6.26661 9.65396 6.46656 9.65396C6.66652 9.65396 6.85829 9.57453 6.99968 9.43314L6.46656 8.90002ZM10.3997 6.03311C10.6941 5.73868 10.6941 5.26132 10.3997 4.96689C10.1053 4.67246 9.6279 4.67246 9.33347 4.96689L10.3997 6.03311ZM4.46689 7.96658L5.93345 9.43314L6.99968 8.36691L5.53311 6.90035L4.46689 7.96658ZM6.99968 9.43314L10.3997 6.03311L9.33347 4.96689L5.93345 8.36691L6.99968 9.43314Z"
                />
            </svg>
        </div>
    );
};

export default Tick;
